module.exports = __webpack_public_path__ + "static/media/IMP_explainer.fcc5267d.jpg";